/* unplugin-vue-components disabled */import { render } from "./xformItem.vue?vue&type=template&id=167258f6"
import script from "./xformItem.vue?vue&type=script&lang=js"
export * from "./xformItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__